/**
 * @generated SignedSource<<9c9a4d69b3756de5cf817a3bba11e164>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row161BadPattern$data = {
  readonly node: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Row353BadPattern" | "Row671BadPattern" | "Row759BadPattern" | "Row856BadPattern">;
  readonly " $fragmentType": "Row161BadPattern";
};
export type Row161BadPattern$key = {
  readonly " $data"?: Row161BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row161BadPattern">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isDensityFull",
    "variableName": "isDensityFull"
  },
  {
    "kind": "Variable",
    "name": "isReparentingEnabled",
    "variableName": "isReparentingEnabled"
  },
  {
    "kind": "Variable",
    "name": "projectKey",
    "variableName": "projectKey"
  },
  {
    "kind": "Variable",
    "name": "projectKeys",
    "variableName": "projectKeys"
  },
  {
    "kind": "Variable",
    "name": "shouldQueryHasChildren",
    "variableName": "shouldQueryHasChildren"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isReparentingEnabled"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shouldQueryHasChildren"
    }
  ],
  "kind": "Fragment",
  "name": "Row161BadPattern",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row671BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row856BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row759BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Row353BadPattern"
    },
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};
})();

(node as any).hash = "c920d894da251b0fb68a6fd04c789c53";

export default node;
